import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#007DC3",
		},
		secondary: {
			main: "rgba(62, 192, 240, 1)",
		},
		blue: {
			main: "#007DC3",
			light: "#EBF5FF",
		},
		black: {
			main: "#131314",
		},
		lightBlue: {
			main: "#007DC3",
		},
		skyBlue: {
			main: "#EBF5FF",
		},
		white: {
			main: "#F8F8F8",
		},
		green: {
			main: "#008000",
			light: "#32cd32",
		},
		red: {
			main: "#ff0000",
		},
		grey: {
			main: "#808080",
			light: "#f2f3f4",
			dark: "#555555",
			lighter : "#EEF2F4"
		},
      orange: {
         main: "#ff4f00"
      },
	  	darkred:{
			main: "#001489",
			light: "#404FA6",
		}
	},
	typography: {
		fontFamily: "tohoma, sans-serif",
		allVariants: {
			color: "#303030",
		},
		subtitle1: {
			fontSize: "16px",
			fontWeight: 700,
		},
		subtitle2: {
			fontSize: "12px",
			fontWeight: 600,
		},
		p12w400: {
			fontSize: "12px",
			fontWeight: 400,
		},
		p14w500: {
			fontSize: "14px",
			fontWeight: 500,
		},
		p12w700: {
			fontSize: "12px",
			fontWeight: 700,
		},
		p14w400: {
			fontSize: "14px",
			fontWeight: 400,
		},
		p14w700: {
			fontSize: "14px",
			fontWeight: 700,
		},
		p16w400: {
			fontSize: "16px",
			fontWeight: 400,
		},
		p16w700: {
			fontSize: "16px",
			fontWeight: 700,
		},
		p18w400: {
			fontSize: "18px",
			fontWeight: 400,
		},
		p18w700: {
			fontSize: "18px",
			fontWeight: 700,
		},
		p20w400: {
			fontSize: "20px",
			fontWeight: 400,
		},
		p20w700: {
			fontSize: "20px",
			fontWeight: 700,
		},
	},
	button: {
		fontFamily: "tohoma, sans-serif",
		fontSize: "14px",
		fontWeight: 600,
		letterSpacing: "0px",
		color: "#f8f8f8",
		textTransform: "none",
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					fontSize: "12px",
					fontWeight: 500,
					textTransform: "none",
					letterSpacing: "1px",
				},
			},
		},
		MuiTabPanel: {
			styleOverrides: {
				root: {
					padding: "0px",
				},
			},
		},
		MuiInputBase :{
			styleOverrides: {
				root:{
					maxHeight: "100px"
				}
			}
		},
		MuiCheckbox :{
			styleOverrides: {
				root:{
					"&.Mui-checked": {
						color: "#001489",
					  },
				}
			}
		},
	},
});

/*
$calym-primary-60: rgba(0, 86, 163, 0.6);
$calym-primary-40: rgba(0, 86, 163, 0.4);
$calym-primary-20: rgba(0, 86, 163, 0.2);

$calym-secondary-60: rgba(62, 192, 240, 0.6);
$calym-secondary-40: rgba(62, 192, 240, 0.4);
$calym-secondary-20: rgba(62, 192, 240, 0.2);

$calym-tertiary: rgba(0, 144, 205, 1);
$calym-tertiary-60: rgba(0, 144, 205, 0.6);
$calym-tertiary-40: rgba(0, 144, 205, 0.4);
$calym-tertiary-20: rgba(0, 144, 205, 0.2);

$calym-quarternary: rgba(32, 40, 86, 1);
$calym-quarternary-60: rgba(32, 40, 86, 0.6);
$calym-quarternary-40: rgba(32, 40, 86, 0.4);
$calym-quarternary-20: rgba(32, 40, 86, 0.2);

$calym-complementary: rgba(147, 198, 199, 1);
$calym-complementary-60: rgba(147, 198, 199, 0.6);
$calym-complementary-40: rgba(147, 198, 199, 0.4);
$calym-complementary-20: rgba(147, 198, 199, 0.2);
*/

export default theme;
